import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import ErrorBoundaryInner from './ErrorBoundaryInner/ErrorBoundaryInner';

interface Props {
  children: React.ReactNode;
}

function ErrorBoundary({ children }: Props) {
  const [hasError, setHasError] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [location.key]);

  return (
    <ErrorBoundaryInner hasError={hasError} setHasError={setHasError}>
      {children}
    </ErrorBoundaryInner>
  );
}

// eslint-disable-next-line import/no-default-export
export default ErrorBoundary;
